import "./style.scss";
const IconWidget = ({ children }) => {
  return <div className="pd_icon_widget">{children}</div>;
};

export default IconWidget;
